import DeviceVerificationVerify from './DeviceVerificationVerify';

export default DeviceVerificationVerify;
